<template>
  <v-btn depressed small class="jbtn-file" :disabled="disabled" style="display: flex;margin-left: 0;">
    <span v-text="title"/>
    <input accept="image/*"
           :rules="fileRules"
            required type="file" v-on:change="fileSelected"></v-btn>
</template>

<script>
  export default {
    name: 'UploadCertificateButton',
    props: {
      selectedCallback: Function,
      title: String,
      disabled: Boolean
    },
    data: () => ({
      fileRules: [
        v => !!v || 'Please upload certificate'
      ]
    }),
    methods: {
      fileSelected (e) {
        if (this.selectedCallback) {
          if (e.target.files[0]) {
            this.selectedCallback(e)
          } else {
            this.selectedCallback(null)
          }
        }
      }
    }
  }
</script>

<style scoped>
  .jbtn-file {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .jbtn-file input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    text-align: right;
    filter: alpha(opacity=0);
    opacity: 0;
    outline: none;
    cursor: inherit;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/widgets/UploadCertificateButton.vue